export default __webpack_public_path__ + "static/media/logo.72950736.png";